import { Box, Button, TextField } from '@mui/material'
import { Formik } from 'formik'
import useMediaQuery from '@mui/material/useMediaQuery'
import Header from '../../components/Header'

import { Select } from '@mui/material'
import { MenuItem } from '@mui/material'

import React from "react"
import { useState, useEffect } from "react"

import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'
import { ArrowDropDown } from '@mui/icons-material'

import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/pt-br'

const AddLivestream = () => {
  const [owners, setOwners] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedOwners, setSelectedOwners] = useState([])

  const fetchOwners = () => {
    fetch(Constants.HOST + '/owners', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            data = data.data
            let newOwners = []
			newOwners.push({
				id: -1,
				name: 'Dispoitivos sem proprietário',
			})
            data.owners.forEach((owner) => {
              newOwners.push({
                id: owner.id,
                name: owner.name,
              })
            })

            setOwners(newOwners)
            setIsLoading(false)
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchOwners()
  }, [])

  const isNonMobile = useMediaQuery('(min-width:600px)')

  let navigate = useNavigate()
  const handleBack = () => {
    navigate('/livestreams')
  }

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  const handleOwnerChange = (event) => {
    setSelectedOwners(event.target.value)
  }

  const handleFormSubmit = (values) => {
    if (selectedOwners.length === 0) {
      setError({
        error: true,
        message: 'Selecione pelo menos um proprietário!',
      })
      setSuccess({ success: false, message: '' })
    } else if (selectedDate < new Date()) {
      setError({ error: true, message: 'Selecione uma data válida!' })
      setSuccess({ success: false, message: '' })
    } else {
      var names = selectedOwners.map((ownerId) => {
        const owner = owners.find((owner) => owner.id === ownerId)
        return owner ? owner.name : '' // If owner is not found, return an empty string
      })
      var ownersString = names.filter(Boolean).join(', ')
      fetch(Constants.HOST + '/createLivestream', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          title: values.title,
          description: values.description,
          url: values.url,
          datetime: selectedDate,
          owners: selectedOwners,
          owners_string: ownersString,
        }),
      })
        .then((response) => {
          if (response.status !== 400 && response.status !== 200) {
            setError({
              error: true,
              message: 'Erro de comunicação com o servidor',
            })
            setSuccess({ success: false, message: '' })
          } else {
            response.json().then((data) => {
              if (data.success) {
                setError({ error: false, message: '' })
                setSuccess({
                  success: true,
                  message: 'Livestream agendada com sucesso',
                })
                values.title = ''
                values.description = ''
                values.url = ''
                values.datetime = ''
                setSelectedOwners([])
              } else {
                setSuccess({ success: false, message: '' })
                setError({ error: true, message: data.message })
              }
            })
          }
        })
        .catch(() => {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        })
    }
  }

  if (isLoading) {
    return <p>Carregando...</p>
  }

  if (owners.length === 0) {
    return (
      <Box m="20px">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Header
            title="Agendar Livestream"
            style={{ width: '100%', gridColumn: 'span 2' }}
          />
          {/* Go back button (X) */}
          <Button
            variant="contained"
            onClick={handleBack}
            sx={{ marginLeft: 'auto', gridColumn: 'span 1', height: '100%' }}
          >
            X
          </Button>
        </Box>
        <Box>
          <p>
            Nenhum proprietário encontrado. Adicione pelo menos um proprietário
            antes de criar notificações.
          </p>
        </Box>
      </Box>
    )
  }

  return (
    <Box m="20px">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Header
          title="Agendar Livestream"
          style={{ width: '100%', gridColumn: 'span 2' }}
        />
        {/* Go back button (X) */}
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginLeft: 'auto', gridColumn: 'span 1', height: '100%' }}
        >
          X
        </Button>
      </Box>

      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Título da notificação"
                onBlur={handleBlur}
                name="title"
                value={values.title}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Descrição da notificação"
                onBlur={handleBlur}
                name="description"
                value={values.description}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Link da livestream (Youtube)"
                onBlur={handleBlur}
                name="url"
                value={values.url}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <label style={{ width: '100%', gridColumn: 'span 2' }}>
                Selecione a data e horário da notificação:
              </label>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
              >
                <DesktopDateTimePicker
                  sx={{ width: '100%', gridColumn: 'span 2' }}
                  ampm={false}
                  selected={selectedDate}
                  onChange={handleDateChange}
                  format="DD/MM/YYYY HH:mm"
                  disablePast={true}
                />
              </LocalizationProvider>
              <label style={{ width: '100%', gridColumn: 'span 2' }}>
                Notificar dispositivos de:
              </label>
              <Select
				MenuProps={{sx: {"&& .Mui-selected": {backgroundColor: "green" }, "&& .Mui-selected:hover": {backgroundColor: "green" }}}}
                sx={{ width: '100%', gridColumn: 'span 2' }}
                multiple
                value={selectedOwners}
                onChange={handleOwnerChange}
                inputProps={{
                  name: 'owners',
                  id: 'owners-select',
                }}
                IconComponent={ArrowDropDown}
              >
                {owners.map((owner) => (
                  <MenuItem key={owner.id} value={owner.id} name={owner.name}>
                    {owner.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
      <div></div>
    </Box>
  )
}

const initialValues = {
  title: '',
  description: '',
  url: '',
}

export default AddLivestream
